import { Flex } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import Container from '../../common/container';
import RegularButton from '../../common/RegularButton';
import PageHeader from '../../common/pageHeader';
import ContinueButton from '../../common/continueButton';
import { useStores } from '../../store/rootStore';
import ProgressBar from '../../common/progressBar';
import BottomSpacer from '../../common/bottomSpacer';
import { EnduranceType } from '../../store/enduranceStore';
import { trackOnboardingCollectedEndurance } from '../../utils/analytics';

export type EnduranceOptionType = {
  title: string;
  value: EnduranceType;
};

const CollectEndurance = observer(() => {
  const { enduranceStore, getNextPagePath } = useStores();

  const navigate = useNavigate();

  const handleContinueButtonClick = () => {
    trackOnboardingCollectedEndurance(enduranceStore.selectedEndurance);
    navigate(getNextPagePath('CollectEndurance'));
  };

  const handleClick = (selectedEndurance: EnduranceType) => {
    enduranceStore.setEndurance(selectedEndurance);
  };

  const enduranceOptions: EnduranceOptionType[] = [
    { title: "I wouldn't make it to the mailbox", value: 'lessThanMailbox' },
    { title: 'To the end of the block', value: 'endOfBlock' },
    { title: 'About a mile or kilometer', value: 'oneMile' },
    { title: '2-3 miles or kilometers', value: 'twoOrThreeMiles' },
    { title: 'A long way', value: 'longWay' },
  ];

  return (
    <Container>
      <ProgressBar currentPage="CollectEndurance" />
      <PageHeader title="How far would you be able to run today?"></PageHeader>
      <Flex direction={'column'}>
        {enduranceOptions.map((option, idx) => (
          <RegularButton
            key={idx}
            title={option.title}
            onClick={() => handleClick(option.value)}
            isSelected={enduranceStore.selectedEndurance === option.value}
          ></RegularButton>
        ))}
      </Flex>
      <BottomSpacer />
      <ContinueButton
        isDisabled={!enduranceStore.selectedEndurance}
        onClick={handleContinueButtonClick}
      />
    </Container>
  );
});

export default CollectEndurance;
